webpackJsonp([213534597649335],{

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["anchor-link"] = factory(require("react"));
		else
			root["anchor-link"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _anchorLink = __webpack_require__(1);
	
	var _anchorLink2 = _interopRequireDefault(_anchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _anchorLink2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnchorLink = function (_Component) {
	  _inherits(AnchorLink, _Component);
	
	  function AnchorLink(props) {
	    _classCallCheck(this, AnchorLink);
	
	    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));
	
	    _this.smoothScroll = _this.smoothScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      __webpack_require__(3).polyfill();
	    }
	  }, {
	    key: 'smoothScroll',
	    value: function smoothScroll(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var offset = function offset() {
	        return 0;
	      };
	      if (typeof this.props.offset !== 'undefined') {
	        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
	          offset = this.props.offset;
	        } else {
	          offset = function offset() {
	            return parseInt(_this2.props.offset);
	          };
	        }
	      }
	      var id = e.currentTarget.getAttribute('href').slice(1);
	      window.scroll({
	        top: document.getElementById(id).offsetTop - offset(),
	        behavior: 'smooth'
	      });
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'a',
	        _extends({}, this.props, { onClick: this.smoothScroll }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return AnchorLink;
	}(_react.Component);
	
	exports.default = AnchorLink;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
	(function () {
	  'use strict';
	
	  /*
	   * aliases
	   * w: window global object
	   * d: document
	   */
	  var w = window;
	  var d = document;
	
	  /**
	   * indicates if a the current browser is made by Microsoft
	   * @method isMicrosoftBrowser
	   * @param {String} userAgent
	   * @returns {Boolean}
	   */
	  function isMicrosoftBrowser(userAgent) {
	    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
	
	    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
	  }
	
	   // polyfill
	  function polyfill() {
	    // return if scroll behavior is supported and polyfill is not forced
	    if ('scrollBehavior' in d.documentElement.style
	      && w.__forceSmoothScrollPolyfill__ !== true) {
	      return;
	    }
	
	    // globals
	    var Element = w.HTMLElement || w.Element;
	    var SCROLL_TIME = 468;
	
	    /*
	     * IE has rounding bug rounding down clientHeight and clientWidth and
	     * rounding up scrollHeight and scrollWidth causing false positives
	     * on hasScrollableSpace
	     */
	    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
	
	    // object gathering original scroll methods
	    var original = {
	      scroll: w.scroll || w.scrollTo,
	      scrollBy: w.scrollBy,
	      elementScroll: Element.prototype.scroll || scrollElement,
	      scrollIntoView: Element.prototype.scrollIntoView
	    };
	
	    // define timing method
	    var now = w.performance && w.performance.now
	      ? w.performance.now.bind(w.performance)
	      : Date.now;
	
	    /**
	     * changes scroll position inside an element
	     * @method scrollElement
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function scrollElement(x, y) {
	      this.scrollLeft = x;
	      this.scrollTop = y;
	    }
	
	    /**
	     * returns result of applying ease math function to a number
	     * @method ease
	     * @param {Number} k
	     * @returns {Number}
	     */
	    function ease(k) {
	      return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    /**
	     * indicates if a smooth behavior should be applied
	     * @method shouldBailOut
	     * @param {Number|Object} firstArg
	     * @returns {Boolean}
	     */
	    function shouldBailOut(firstArg) {
	      if (firstArg === null
	        || typeof firstArg !== 'object'
	        || firstArg.behavior === undefined
	        || firstArg.behavior === 'auto'
	        || firstArg.behavior === 'instant') {
	        // first argument is not an object/null
	        // or behavior is auto, instant or undefined
	        return true;
	      }
	
	      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
	        // first argument is an object and behavior is smooth
	        return false;
	      }
	
	      // throw error when behavior is not supported
	      throw new TypeError(
	        'behavior member of ScrollOptions '
	        + firstArg.behavior
	        + ' is not a valid value for enumeration ScrollBehavior.'
	      );
	    }
	
	    /**
	     * indicates if an element has scrollable space in the provided axis
	     * @method hasScrollableSpace
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function hasScrollableSpace(el, axis) {
	      if (axis === 'Y') {
	        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
	      }
	
	      if (axis === 'X') {
	        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
	      }
	    }
	
	    /**
	     * indicates if an element has a scrollable overflow property in the axis
	     * @method canOverflow
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function canOverflow(el, axis) {
	      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
	
	      return overflowValue === 'auto' || overflowValue === 'scroll';
	    }
	
	    /**
	     * indicates if an element can be scrolled in either axis
	     * @method isScrollable
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function isScrollable(el) {
	      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
	      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
	
	      return isScrollableY || isScrollableX;
	    }
	
	    /**
	     * finds scrollable parent of an element
	     * @method findScrollableParent
	     * @param {Node} el
	     * @returns {Node} el
	     */
	    function findScrollableParent(el) {
	      var isBody;
	
	      do {
	        el = el.parentNode;
	
	        isBody = el === d.body;
	      } while (isBody === false && isScrollable(el) === false);
	
	      isBody = null;
	
	      return el;
	    }
	
	    /**
	     * self invoked function that, given a context, steps through scrolling
	     * @method step
	     * @param {Object} context
	     * @returns {undefined}
	     */
	    function step(context) {
	      var time = now();
	      var value;
	      var currentX;
	      var currentY;
	      var elapsed = (time - context.startTime) / SCROLL_TIME;
	
	      // avoid elapsed times higher than one
	      elapsed = elapsed > 1 ? 1 : elapsed;
	
	      // apply easing to elapsed time
	      value = ease(elapsed);
	
	      currentX = context.startX + (context.x - context.startX) * value;
	      currentY = context.startY + (context.y - context.startY) * value;
	
	      context.method.call(context.scrollable, currentX, currentY);
	
	      // scroll more if we have not reached our destination
	      if (currentX !== context.x || currentY !== context.y) {
	        w.requestAnimationFrame(step.bind(w, context));
	      }
	    }
	
	    /**
	     * scrolls window or element with a smooth behavior
	     * @method smoothScroll
	     * @param {Object|Node} el
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function smoothScroll(el, x, y) {
	      var scrollable;
	      var startX;
	      var startY;
	      var method;
	      var startTime = now();
	
	      // define scroll context
	      if (el === d.body) {
	        scrollable = w;
	        startX = w.scrollX || w.pageXOffset;
	        startY = w.scrollY || w.pageYOffset;
	        method = original.scroll;
	      } else {
	        scrollable = el;
	        startX = el.scrollLeft;
	        startY = el.scrollTop;
	        method = scrollElement;
	      }
	
	      // scroll looping over a frame
	      step({
	        scrollable: scrollable,
	        method: method,
	        startTime: startTime,
	        startX: startX,
	        startY: startY,
	        x: x,
	        y: y
	      });
	    }
	
	    // ORIGINAL METHODS OVERRIDES
	    // w.scroll and w.scrollTo
	    w.scroll = w.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scroll.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : (w.scrollX || w.pageXOffset),
	          // use top prop, second argument if present or fallback to scrollY
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	              ? arguments[1]
	              : (w.scrollY || w.pageYOffset)
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        arguments[0].left !== undefined
	          ? ~~arguments[0].left
	          : (w.scrollX || w.pageXOffset),
	        arguments[0].top !== undefined
	          ? ~~arguments[0].top
	          : (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // w.scrollBy
	    w.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollBy.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : 0,
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	             ? arguments[1]
	             : 0
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
	        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // Element.prototype.scroll and Element.prototype.scrollTo
	    Element.prototype.scroll = Element.prototype.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        // if one number is passed, throw error to match Firefox implementation
	        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
	          throw new SyntaxError('Value couldn\'t be converted');
	        }
	
	        original.elementScroll.call(
	          this,
	          // use left prop, first number argument or fallback to scrollLeft
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? ~~arguments[0]
	              : this.scrollLeft,
	          // use top prop, second argument or fallback to scrollTop
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top
	            : arguments[1] !== undefined
	              ? ~~arguments[1]
	              : this.scrollTop
	        );
	
	        return;
	      }
	
	      var left = arguments[0].left;
	      var top = arguments[0].top;
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        this,
	        this,
	        typeof left === 'undefined' ? this.scrollLeft : ~~left,
	        typeof top === 'undefined' ? this.scrollTop : ~~top
	      );
	    };
	
	    // Element.prototype.scrollBy
	    Element.prototype.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.elementScroll.call(
	          this,
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left + this.scrollLeft
	            : ~~arguments[0] + this.scrollLeft,
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top + this.scrollTop
	            : ~~arguments[1] + this.scrollTop
	        );
	
	        return;
	      }
	
	      this.scroll({
	        left: ~~arguments[0].left + this.scrollLeft,
	        top: ~~arguments[0].top + this.scrollTop,
	        behavior: arguments[0].behavior
	      });
	    };
	
	    // Element.prototype.scrollIntoView
	    Element.prototype.scrollIntoView = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scrollIntoView.call(
	          this,
	          arguments[0] === undefined
	            ? true
	            : arguments[0]
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      var scrollableParent = findScrollableParent(this);
	      var parentRects = scrollableParent.getBoundingClientRect();
	      var clientRects = this.getBoundingClientRect();
	
	      if (scrollableParent !== d.body) {
	        // reveal element inside parent
	        smoothScroll.call(
	          this,
	          scrollableParent,
	          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
	          scrollableParent.scrollTop + clientRects.top - parentRects.top
	        );
	
	        // reveal parent in viewport unless is fixed
	        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
	          w.scrollBy({
	            left: parentRects.left,
	            top: parentRects.top,
	            behavior: 'smooth'
	          });
	        }
	      } else {
	        // reveal element in viewport
	        w.scrollBy({
	          left: clientRects.left,
	          top: clientRects.top,
	          behavior: 'smooth'
	        });
	      }
	    };
	  }
	
	  if (true) {
	    // commonjs
	    module.exports = { polyfill: polyfill };
	  } else {
	    // global
	    polyfill();
	  }
	
	}());
	
	
	/***/ })
	/******/ ]);
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdAccessTime = function MdAccessTime(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.9 11.6v8.8l7.5 4.4-1.3 2.2-8.7-5.4v-10h2.5z m-0.9 21.8q5.5 0 9.4-4t4-9.4-4-9.4-9.4-4-9.4 4-4 9.4 4 9.4 9.4 4z m0-30q6.9 0 11.8 4.8t4.8 11.8-4.8 11.8-11.8 4.8-11.8-4.8-4.8-11.8 4.8-11.8 11.8-4.8z' })
	        )
	    );
	};
	
	exports.default = MdAccessTime;
	module.exports = exports['default'];

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdList = function MdList(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 11.6h23.4v3.4h-23.4v-3.4z m0 16.8v-3.4h23.4v3.4h-23.4z m0-6.8v-3.2h23.4v3.2h-23.4z m-6.6-6.6v-3.4h3.4v3.4h-3.4z m0 13.4v-3.4h3.4v3.4h-3.4z m0-6.8v-3.2h3.4v3.2h-3.4z' })
	        )
	    );
	};
	
	exports.default = MdList;
	module.exports = exports['default'];

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountDownTimer = function (_React$Component) {
	  _inherits(CountDownTimer, _React$Component);
	
	  function CountDownTimer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CountDownTimer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      days: '',
	      hours: '',
	      minutes: '',
	      seconds: '',
	      letsCelebrate: false
	    }, _this.componentDidMount = function () {
	      _this.getDistance();
	      _this.intervalId = setInterval(_this.getDistance, 1000);
	    }, _this.componentWillUnmount = function () {
	      clearInterval(_this.intervalId);
	    }, _this.getDistance = function () {
	      var distance = Date.parse(_this.props.date) - Date.parse(new Date());
	      if (distance <= 0) {
	        _this.setState({
	          days: 0,
	          hours: 0,
	          minutes: 0,
	          seconds: 0,
	          letsCelebrate: true
	        });
	      } else {
	        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
	        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
	        var seconds = Math.floor(distance % (1000 * 60) / 1000);
	
	        _this.setState({
	          days: days, hours: hours, minutes: minutes, seconds: seconds
	        });
	      }
	    }, _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'countDownTimer flex column' },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement('script', { src: 'https://static.nrk.no/ludo/latest/video-embed.js' })
	        ),
	        !_this.state.letsCelebrate ? _react2.default.createElement(
	          'div',
	          { className: 'flex center row wrap' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _this.state.days,
	            'd'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _this.state.hours,
	            't'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _this.state.minutes,
	            'm'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            _this.state.seconds,
	            's'
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'button' },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.nrk.no/video/PS*a2c8daef-4299-48e9-ada1-27043c18d7d9' },
	              'SE SENDINGEN LIVE'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'button' },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.nrk.no/kultur/grieg_-minutt-for-minutt-1.14081196' },
	              'F\xD8LG NETTPRATEN'
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return CountDownTimer;
	}(_react2.default.Component);
	
	exports.default = CountDownTimer;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(20);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DualLink = function DualLink(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex center dualLink' },
	    _react2.default.createElement(
	      'div',
	      { className: 'button postButton' },
	      _react2.default.createElement(
	        'a',
	        { href: 'http://harmonien.no/konserter-og-billetter/2018/06/grieg-minutt-for-minutt/', target: '_blank' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Kj\xF8p billetter til Grieghallen her'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'button postButton' },
	      props.link1 ? _react2.default.createElement(
	        _reactAnchorLinkSmoothScroll2.default,
	        { href: '#' + props.link1 },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.children
	        )
	      ) : _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: props.link2 },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.children
	        )
	      )
	    )
	  );
	};
	exports.default = DualLink;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FadeInWrapper = __webpack_require__(7);
	
	var _FadeInWrapper2 = _interopRequireDefault(_FadeInWrapper);
	
	var _BgImage = __webpack_require__(10);
	
	var _BgImage2 = _interopRequireDefault(_BgImage);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Footer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'footer flex center column' },
	        _react2.default.createElement(
	          'div',
	          { className: 'bgImageWrapper' },
	          _react2.default.createElement(_BgImage2.default, { sizes: _this.props.src, height: '400', position: _this.props.position, fit: _this.props.fit })
	        ),
	        _react2.default.createElement(
	          _FadeInWrapper2.default,
	          { id: 'footer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'footerLinks flex wrap basePad center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'button' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/opus-for-opus' },
	                'Opus for opus'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'button' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/artister' },
	                'Artister'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'button' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/info' },
	                'Info'
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BgImage = __webpack_require__(10);
	
	var _BgImage2 = _interopRequireDefault(_BgImage);
	
	var _CountDownTimer = __webpack_require__(748);
	
	var _CountDownTimer2 = _interopRequireDefault(_CountDownTimer);
	
	var _ScrollToAnchor = __webpack_require__(836);
	
	var _ScrollToAnchor2 = _interopRequireDefault(_ScrollToAnchor);
	
	var _ZoomIn = __webpack_require__(749);
	
	var _ZoomIn2 = _interopRequireDefault(_ZoomIn);
	
	var _list = __webpack_require__(736);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainEntrance = function (_React$Component) {
	  _inherits(MainEntrance, _React$Component);
	
	  function MainEntrance() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MainEntrance);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'mainEntrance flex center', style: { height: _this.props.windowHeight } },
	        _react2.default.createElement(
	          'div',
	          { className: 'mainEntranceImg flex center column' },
	          _react2.default.createElement(_BgImage2.default, { sizes: _this.props.src, position: _this.props.position, fit: _this.props.fit }),
	          _react2.default.createElement(
	            _ZoomIn2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'flex center column flexStart' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'GRIEG'
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'MINUTT'
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'FOR'
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                'MINUTT'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mainEntranceText flex column center' },
	          _react2.default.createElement(_CountDownTimer2.default, { date: 'Jun 15, 2018 17:30:00' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'mainEntranceTextInfo flex center column' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              '15. juni kl. 17.30 starter verdens lengste fremf\xF8relse av Edvard Griegs musikk. NRK direktesender 30 timer med live musikk fra Griegs hjem Troldhaugen, Grieghallen og fra Store Studio. Vi lanserer artistene gradvis. F\xF8lg med her!'
	            )
	          ),
	          _react2.default.createElement(_ScrollToAnchor2.default, {
	            anchorId: 'mainSeller1',
	            scrollSpeed: 1000
	          })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return MainEntrance;
	}(_react2.default.Component);
	
	exports.default = MainEntrance;
	module.exports = exports['default'];

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BgImage = __webpack_require__(10);
	
	var _BgImage2 = _interopRequireDefault(_BgImage);
	
	var _Overcast = __webpack_require__(38);
	
	var _Overcast2 = _interopRequireDefault(_Overcast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainHero = function (_React$Component) {
	  _inherits(MainHero, _React$Component);
	
	  function MainHero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MainHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        "div",
	        { className: "hero mainHero flex center" },
	        _react2.default.createElement(_BgImage2.default, { sizes: _this.props.src, height: _this.props.height, position: _this.props.position, fit: _this.props.fit }),
	        _react2.default.createElement(_Overcast2.default, { id: _this.props.id, height: "1" })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return MainHero;
	}(_react2.default.Component);
	
	exports.default = MainHero;
	module.exports = exports["default"];

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FadeInWrapper = __webpack_require__(7);
	
	var _FadeInWrapper2 = _interopRequireDefault(_FadeInWrapper);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _accessTime = __webpack_require__(796);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _NavLinks = __webpack_require__(835);
	
	var _NavLinks2 = _interopRequireDefault(_NavLinks);
	
	var _DualLink = __webpack_require__(75);
	
	var _DualLink2 = _interopRequireDefault(_DualLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainInfoText = function MainInfoText() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'mainInfoText flex center row blogPost basePad' },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex center column ' },
	      _react2.default.createElement(
	        _FadeInWrapper2.default,
	        { id: 'mainInfoText1' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Edvard Grieg 175 \xE5r'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          '#nrkgrieg'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'NRK, Bergen Filharmoniske Orkester & KODE'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'basePad' },
	        _react2.default.createElement(
	          _FadeInWrapper2.default,
	          { id: 'mainInfoText2' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            '15. juni 2018 er det 175 \xE5r siden Edvard Grieg ble f\xF8dt. Vi markerer dagen med verdens lengste Grieg-konsert, 30 timer direkte p\xE5 NRK!'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'En klassisk musikkfest i Bergen! Grieg minutt for minutt er en enest\xE5ende anledning til \xE5 oppleve hele Griegs produksjon fra opus 1\u201374, fremf\xF8rt av det beste fra norsk musikkliv. Troldhaugen, Edvard Griegs hjem, blir \xE5pent gjennom hele arrangementet og et sentrum for den store folkefesten. Det blir ogs\xE5 store arrangementer og opplevelser i Grieghallen, med Bergen Filharmoniske Orkester, kor og andre musikere. Ogs\xE5 Kringkastingsorkesteret bidrar med stor musikk fra Store Studio. Kanskje blir det innslag fra andre deler av landet ogs\xE5!'
	          )
	        ),
	        _react2.default.createElement(
	          _FadeInWrapper2.default,
	          { id: 'mainInfoText3' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Listen over artister og Griegs opusnumre oppdateres fortl\xF8pende. Programmet g\xE5r fra ettermiddagen 15. juni og til n\xE6rmere midnatt 16. juni. Du er herved invitert til Edvard Griegs 175-\xE5rsdag, bli med p\xE5 festen, dag og natt!'
	          )
	        ),
	        _react2.default.createElement(
	          _FadeInWrapper2.default,
	          { id: 'mainInfoAnchorLinks' },
	          _react2.default.createElement(
	            _DualLink2.default,
	            { link2: 'info#Troldhaugen' },
	            'Gratis p\xE5 Troldhaugen og i Store studio'
	          ),
	          _react2.default.createElement(_NavLinks2.default, { link1: 'Opus for opus', link2: 'Artister', link3: 'Info' })
	        ),
	        _react2.default.createElement(
	          _FadeInWrapper2.default,
	          { id: 'mainInfoText4' },
	          _react2.default.createElement(
	            'h2',
	            { style: { marginTop: "1rem" } },
	            'Partnere'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Prosjektet \xABGrieg minutt for minutt\xBB er et initiativ fra KODE Kunstmuseer og komponisthjem og Musikkselskapet Harmonien. Innholdet produseres av KODE, Bergen Filharmoniske Orkester og Kringkastingsorkesteret, med viktige bidrag fra Griegakademiet ved Universitetet i Bergen, Norges Musikkh\xF8gskole og Bergen Filharmoniske Ungdomsorkester. Et stort antall frilansmusikere og kor deltar. Grieg minutt for minutt er en nasjonal musikkdugnad med over 600 sangere og musikere. Bergen kommune bidrar ogs\xE5 til festen, og samarbeider bredt med b\xE5de frivillige kor og korps, med kulturskolene og skolene, om sidearrangementer f\xF8r og under den store jubileumsmarkeringen.'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Prosjektet hadde ikke v\xE6rt mulig uten st\xF8tte fra Sparebankstiftelsen DNB til KODE Kunstmuseer og komponisthjem. '
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = MainInfoText;
	module.exports = exports['default'];

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FadeInWrapper = __webpack_require__(7);
	
	var _FadeInWrapper2 = _interopRequireDefault(_FadeInWrapper);
	
	var _accessTime = __webpack_require__(796);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainSeller = function MainSeller() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'mainSeller flex center row' },
	    _react2.default.createElement(
	      _FadeInWrapper2.default,
	      { id: 'mainSeller1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sellPoint flex center column' },
	        _react2.default.createElement(_accessTime2.default, null),
	        _react2.default.createElement(
	          'h2',
	          null,
	          '30 timer'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _FadeInWrapper2.default,
	      { id: 'mainSeller2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sellPoint flex center column' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          '600+'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'musikere'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _FadeInWrapper2.default,
	      { id: 'mainSeller3' },
	      _react2.default.createElement(
	        'div',
	        { className: 'sellPoint flex center column' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          '15 & 16'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'juni 2018'
	        )
	      )
	    )
	  );
	};
	exports.default = MainSeller;
	module.exports = exports['default'];

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CountDownTimer = __webpack_require__(748);
	
	var _CountDownTimer2 = _interopRequireDefault(_CountDownTimer);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _GriegNightInv = __webpack_require__(1509);
	
	var _GriegNightInv2 = _interopRequireDefault(_GriegNightInv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainStarter = function (_React$Component) {
	  _inherits(MainStarter, _React$Component);
	
	  function MainStarter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MainStarter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.render = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'mainStarter flex row', style: { height: _this.props.windowHeight } },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement(_CountDownTimer2.default, { date: 'Jun 15, 2018 17:30:00' })
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/opus-for-opus' },
	          _react2.default.createElement('img', { src: _GriegNightInv2.default, alt: 'Grieg by day, Grieg by night' }),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Opus For Opus'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Les mer om Griegs musikk'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'underline' },
	            _react2.default.createElement(
	              'h2',
	              { style: { marginBottom: "0.51rem" } },
	              '15. & 16. juni 2018'
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Les mer om arrangementet'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return MainStarter;
	}(_react2.default.Component);
	
	exports.default = MainStarter;
	module.exports = exports['default'];

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLinks = function NavLinks(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex center' },
	    _react2.default.createElement(
	      'div',
	      { className: 'button infoButton' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: props.link1.split(" ").join("-").toLowerCase() },
	        props.link1
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'button infoButton' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: props.link2.split(" ").join("-").toLowerCase() },
	        props.link2
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'button infoButton' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: props.link3.split(" ").join("-").toLowerCase() },
	        props.link3
	      )
	    )
	  );
	};
	exports.default = NavLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollToAnchor = function (_React$Component) {
	  _inherits(ScrollToAnchor, _React$Component);
	
	  function ScrollToAnchor() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollToAnchor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      opacity: 0
	    }, _this.getElementY = function (query) {
	      return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	    }, _this.doScrolling = function (element, duration) {
	      var startingY = window.pageYOffset;
	      var elementY = _this.getElementY(element);
	      // If element is close to page's bottom then window will scroll only to some position above the element.
	      var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	      var diff = targetY - startingY;
	      // Easing function: easeInOutCubic From: https://gist.github.com/gre/1650294
	      var easing = function easing(t) {
	        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	      };
	      var start = void 0;
	      if (!diff) return;
	      // Bootstrap our animation - it will get called right before next frame shall be rendered.
	      window.requestAnimationFrame(function step(timestamp) {
	        if (!start) start = timestamp;
	        // Elapsed miliseconds since start of scrolling.
	        var time = timestamp - start;
	        // Get percent of completion in range [0, 1].
	        var percent = Math.min(time / duration, 1);
	        // Apply the easing.
	        // It can cause bad-looking slow frames in browser performance tool, so be careful.
	        percent = easing(percent);
	        window.scrollTo(0, startingY + diff * percent);
	        // Proceed with animation as long as we wanted it to.
	        if (time < duration) {
	          window.requestAnimationFrame(step);
	        }
	      });
	    }, _this.setTimer = function () {
	      setTimeout(function () {
	        return _this.setState({
	          opacity: 1
	        });
	      }, 1500);
	    }, _this.componentDidMount = function () {
	      _this.setTimer();
	    }, _this.render = function () {
	      var styles = {
	        zIndex: "99",
	        opacity: _this.state.opacity,
	        transition: "0.5s ease-in",
	        marginBottom: '1rem'
	      };
	      return _react2.default.createElement(
	        "div",
	        { style: styles },
	        _this.props.children,
	        _react2.default.createElement(
	          "div",
	          { onClick: function onClick() {
	              _this.doScrolling("#" + _this.props.anchorId, _this.props.scrollSpeed);
	            }, className: "mouse scrollToAnchorMouse" },
	          _react2.default.createElement("div", { className: "scrollbutton scrollToAnchorButton" })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return ScrollToAnchor;
	}(_react2.default.Component);
	
	exports.default = ScrollToAnchor;
	module.exports = exports["default"];

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(54);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(12);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _MainEntrance = __webpack_require__(827);
	
	var _MainEntrance2 = _interopRequireDefault(_MainEntrance);
	
	var _MainHero = __webpack_require__(828);
	
	var _MainHero2 = _interopRequireDefault(_MainHero);
	
	var _MainSeller = __webpack_require__(830);
	
	var _MainSeller2 = _interopRequireDefault(_MainSeller);
	
	var _MainInfoText = __webpack_require__(829);
	
	var _MainInfoText2 = _interopRequireDefault(_MainInfoText);
	
	var _MainStarter = __webpack_require__(831);
	
	var _MainStarter2 = _interopRequireDefault(_MainStarter);
	
	var _Footer = __webpack_require__(36);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _GriegMinuttForMinutt = __webpack_require__(51);
	
	var _GriegMinuttForMinutt2 = _interopRequireDefault(_GriegMinuttForMinutt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Index);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      windowWidth: '',
	      windowHeight: ''
	    }, _this.handleResize = function () {
	      var w = window,
	          d = document,
	          e = d.documentElement,
	          g = d.getElementsByTagName('body')[0],
	          x = w.innerWidth || e.clientWidth || g.clientWidth,
	          y = w.innerHeight || e.clientHeight || g.clientHeight;
	      _this.setState({
	        windowWidth: x,
	        windowHeight: y
	      });
	    }, _this.componentDidMount = function () {
	      _this.handleResize();
	      window.addEventListener('resize', _this.handleResize);
	    }, _this.componentWillUnmount = function () {
	      window.removeEventListener('resize', _this.handleResize);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { pageImg: _GriegMinuttForMinutt2.default }),
	      _react2.default.createElement(_MainEntrance2.default, {
	        id: "MainEntrance",
	        src: this.props.data.front2.childImageSharp.sizes,
	        windowHeight: this.state.windowHeight
	      }),
	      _react2.default.createElement(_MainSeller2.default, null),
	      _react2.default.createElement(_MainInfoText2.default, null),
	      _react2.default.createElement(_Footer2.default, { src: this.props.data.front.childImageSharp.sizes })
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off"*/
	
	
	exports.default = Index;
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GriegMinuttForMinutt.99794b9b.jpg";

/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GriegNightInv.c3130b02.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-3375f9cb46702aca91da.js